module.exports = __webpack_public_path__ + "img/3@3x.a3d42772.png";